<template>
  <img :src="icon" :width="size" :height="size" :alt="platform" />
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  platform: {
    type: String,
  },
  size: {
    type: Number,
    default: 24
  }
})

const icon = computed(() => {
  const domain = props.platform.toLowerCase() + '.com'
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=${props.size}`
})
</script>


<style scoped lang="scss">

</style>
